// src/features/presence/realtime-section.tsx
import { KpiTile } from "@/components/iris";
import { Kicker } from "@/components/iris/kicker";
import { formatCount } from "@/lib/format-count";
import type { Env, PresenceRealtime } from "@/lib/types";
import { Activity, Layers, Moon, TrendingUp, Users } from "lucide-react";

interface RealtimeSectionProps {
  data: PresenceRealtime;
  env: Env;
}

/**
 * IR-1148 §1 — live presence KPI row: who's connected/active/idle right now,
 * current concurrency, and the rolling peaks. Env-tagged tiles (the glow color
 * follows the selected env).
 */
export function RealtimeSection({ data, env }: RealtimeSectionProps) {
  const kpiEnv = env === "dev" ? "dev" : "prod";
  return (
    <>
      <Kicker style={{ marginTop: 8, marginBottom: 12 }}>Live Presence</Kicker>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 16 }}>
        <KpiTile
          label="Connected"
          value={formatCount(data.connected)}
          icon={Users}
          tone="cyan"
          env={kpiEnv}
        />
        <KpiTile
          label="Active"
          value={formatCount(data.active)}
          icon={Activity}
          tone="magenta"
          env={kpiEnv}
        />
        <KpiTile
          label="Idle"
          value={formatCount(data.idle)}
          icon={Moon}
          tone="purple"
          env={kpiEnv}
        />
        <KpiTile
          label="Concurrent"
          value={formatCount(data.concurrent)}
          icon={Layers}
          tone="orange"
          env={kpiEnv}
        />
        <KpiTile
          label="Peak Concurrent"
          value={formatCount(data.peak_concurrent_users)}
          icon={TrendingUp}
          tone="cyan"
          env={kpiEnv}
        />
        <KpiTile
          label="Peak Active"
          value={formatCount(data.peak_active_users)}
          icon={TrendingUp}
          tone="magenta"
          env={kpiEnv}
        />
      </div>
    </>
  );
}
